<template>
  <div class="content">
  
    <div class="container-fluid">
      <div class="row">
        <el-col class="ColonneGauche" >
          <span style="margin-left:20px">Date début :</span>
          <el-date-picker style="margin-left:10px;width:130px;" size='mini' class="selectColDroite" v-model="dte_deb" type="date"
            placeholder="Date" value-format="dd-MM-yyyy" format="dd-MM-yyyy"
            @change='reloadAll'>
          </el-date-picker> 

          <span style="margin-left:20px">Date fin :</span>
          <el-date-picker style="margin-left:10px;width:130px;" size='mini' class="selectColDroite" v-model="dte_fin" type="date"
            placeholder="Date" value-format="dd-MM-yyyy" format="dd-MM-yyyy"
            @change='reloadAll'>
          </el-date-picker>

          <!--<label for="cloturee" style="margin-left:50px;font-weight : bold;"> Inclure l’historique :</label>
            <el-switch style="margin-left:10px;"
                    name='cloturee'
                    v-model="include_histo"
                    @change="handlecloturee()"
                    >
            </el-switch>-->
        </el-col>
        
      </div>

      
      <div class="row">
        <!--<div class="col-xl-3 col-md-6">
          <stats-card>
            
            <div slot="content">
              <p class="card-category" style="width:160px">Nombre d'actions Créés</p>
              <h4 class="card-title">{{nbr_create}}</h4>
            </div>
          </stats-card>
        </div>

        <div style="width:600px">
          <div id='Zone'>
						<div>Actions En cours: {{nbr_ec}}</div>
					</div>

          <div id='Zone'>
            <div>Actions En retard: {{nbr_retard}}</div>
          </div>
        
          <div id='Zone'>
            <div>Actions Cloturées: {{nbr_clot}}</div>
          </div>
        </div>
-->
      </div>

      <div class="row">
          <canvas id="barChart"></canvas>
      </div> 

      <div class="row">
        
          <canvas id="camembertChart"></canvas>
        
          <canvas id="camembertChart2"></canvas>
        
          <canvas id="camembertChart3"></canvas>
        
      </div>

    </div>
  </div>


</template>

<script>
  import $ from 'jquery'
  import axios from 'axios';
  import {BACKEND_URL} from './GLOBALS'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import moment from "moment"
  import chart from '../chart.js'
  import stat from '../components/stat.js'

    export default {
      components: {
        LTable,
        ChartCard,
        StatsCard
      },
      name:'Home',
      data() {
        return {
          include_histo: 0,
          open:true,
          test:'test',  
          optionsNom_Cli:'',
          optionsObjet:'',
          optionsPriorite:'',
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        pieChart: {
          data: {
            labels: ['40%', '20%', '40%'],
            series: [40, 20, 40]
          }
        },
        lineChart: {
          data: {
            labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
            series: [
              [287, 385, 490, 492, 554, 586, 698, 695],
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [412, 243, 280, 580, 453, 353, 300, 364, 368, 410, 636, 695]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        tableData: [],
        columnsTitle: [
        "",
        "N° Action",
        "Etat",
        "Objet",
        "Date ",
        "N° Client",
        "Action"
        ],
        //dte_deb: this.subtractMonths(new Date(),3),
        dte_deb:'',
        dte_fin: '',
        nbr_create:0,
        nbr_ec:0,
        nbr_retard:0,
        nbr_clot:0,
      }
    },
      computed: {
      },
      watch: {
      },
      /*created() {
       this.reloadNbr()
      },*/
      mounted() {
        this.reloadAll();
      },
      methods: {
        subtractMonths(date, months) {
          date.setMonth(date.getMonth() - months);
          return date;
        },
        reloadNbr() {
          var self = this
          var request = $.ajax({
              url: BACKEND_URL+"controller/stats.php",
              async: false,
              type: "POST",
              data: {
                'dte_deb': moment(self.dte_deb, "DD-MM-yyyy").format("DD-MM-yyyy"),
                'dte_fin': moment(self.dte_fin, "DD-MM-yyyy").format("DD-MM-yyyy"),
                'restriction': self.$store.getters.restriction,
                'vendeur': self.$store.getters.vendeur,
                'include_histo': self.include_histo ? 1 : 0
              },
              dataType: "html",
              success: function(data) {
                //console.log(data)
                var dataParsed = JSON.parse(data)
                self.nbr_create = dataParsed.NBR
                self.nbr_ec = dataParsed.NB_OUVERT
                self.nbr_retard = dataParsed.NB_RETARD
                self.nbr_clot = dataParsed.NB_REALISE
              }
          })
        },
        reloadAll() {
          const dte_deb_f = moment(this.dte_deb, "DD-MM-yyyy").format("DD-MM-yyyy")
          const dte_fin_f = moment(this.dte_fin, "DD-MM-yyyy").format("DD-MM-yyyy")
          const restrections = this.$store.getters.restriction
          const vendeur    = this.$store.getters.vendeur
          const incl_histo = this.include_histo ? 1 : 0
          this.reloadNbr()
          const retard_data = [this.nbr_retard, this.nbr_ec, this.nbr_clot];
          stat.loadcamembers($, BACKEND_URL, retard_data, dte_deb_f, dte_fin_f, restrections, vendeur, incl_histo)
        },
        handlecloturee(val) {
          this.reloadAll();
        }
      }
    }
  
</script>

<style>
#Zone {
  display: inline-block;
  width: 180px;
  height: 30px;
  margin-left:20px;
  padding: 7px;
  font-family: verdana;
  background-color: white;
  border: 2px solid rgb(190, 190, 190);
  border-radius: 2px;
}
</style>